import Footer from "../footer"
import NavBar from "../nav"

const Whitepapers = () => {
  return <div className='whitepapers'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>White Papers</h1>
				<div className="headline-divider sections"></div>
				<h2>Aviation. Safety. Compliance.</h2>
				<h3>Fly Compliant's Evolving POV</h3>
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="container content-container square-container">	
				<div className="grid-1 callout">
					<div className="prose-header">The Evolution of SMS</div>
					<div className="prose">Safety Management needs to be participated by all stakeholders and seen as an industry standard not just specific to any one company. Safety management for General Aviation industry has not been fully realized.</div>
					<div className="prose"><a href="/uploads/whitepapers/1/The-Evolution-of-SMS.pdf" target="_blank" rel="noreferrer">Download Article</a></div>
				</div>	
				
			</div>	
		</section>
    </div>
    <Footer />
  </div>
}

export default Whitepapers